module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS1zdGFydCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgIDxwYXRoIGQ9Ik04IDIgTDggMTYgMjIgMiAyMiAzMCA4IDE2IDggMzAiIC8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-start.svg
// module id = 0JiT
// module chunks = 53